export function preventDialogModalCloseOnEscape(dialog) {
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
  });
}

export function closeOnSubmit(dialog, buttons) {
  function closeDialog() {
    dialog.close();
  }

  // if buttons contains multiple elements
  if (buttons.length > 0) {
    for (let button of buttons) {
      button.addEventListener('click', closeDialog);
    }
    return;
  }
  // If buttons is a single element
  buttons.addEventListener('click', closeDialog);
}
